import type {
    InviteByEmailData,
    LcaShareConvertResponse,
    LcaShareLinkResponse,
    ShareAuthCheckData,
    ShareLinkResponse,
} from '../types';

export interface ShareService {
    getShareId(data: ShareAuthCheckData): Promise<ShareLinkResponse>;
    inviteByEmail(data: InviteByEmailData): Promise<void>;
    createLSShareId(data: {file_group_id: string}): Promise<{share_id: string}>
    createLcaShareId(data: {job_id: string}): Promise<LcaShareLinkResponse>
    convertLcaShare(jobId: string): Promise<LcaShareConvertResponse>
    sendPDAShareByEmail(data: {share_id: string, receptor: string[]}): Promise<boolean>
}

export const ShareService = Symbol('ShareService');
